import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export interface IMajorCourseMap {
  title: string;
  code: string;
  nk: string;
  credits?: number;
  isGroup: boolean;
  description: string;
  hasPreReq: boolean;
  hasCoReq: boolean;
}

export class MajorCourseMapProgram implements IIndexable {
  id: number;
  slot: number;
  desc: string;
  courses: Array<{
    course_id: number;
  }>;
  status?: any;
  is_course_planned: boolean;
  is_course_group_planned: boolean;
  is_devreq: boolean;
  term_slot_group?: any;
  total_courses: number;
  min_credits: number;
  max_credits: number;
  course_group: string;

  constructor(program: Partial<MajorCourseMapProgram>) {
    _4.merge(this, program);
  }

  static build(program: Partial<MajorCourseMapProgram>): MajorCourseMapProgram {
    return new MajorCourseMapProgram(program);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/builders/major_course_map_program_builder.ts